<template>
  <div>
    <main class="main-content">
      <div class="card">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center">
            <h6 class="card-title">نمایش گزارش های روزانه کاربر</h6>
          </div>
          <div class="d-flex justify-content-center height" v-if="data==null" >
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">در حال بارگذاری ...</span>
            </div>
          </div>
          <div class="table-responsive" v-else>
            <table class="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>ردیف</th>
                  <th>کدپروژه</th>
                  <th>نام پروژه</th>
                  <th>تاریخ</th>
                  <th>گزارش</th>
                </tr>
              </thead>
              <tbody v-for="(group, key ,count) in data" :key="count">
                <tr >
                  <td colspan="5">
                      <router-link :to="{
                          name:'staff.reports.print',
                          params: { id: id, date: key }
                        }" class="btn btn-outline-primary btn-block">
                        {{key}}
                      </router-link>
                  </td>
                </tr>
                <tr scope="row" v-for="(report , index) in group" :key="index">
                  <td>{{index+1}}</td>
                  <td v-text="report.project.code"></td>
                  <td v-text="report.project.name"></td>
                  <td v-text="report.time"></td>
                  <td v-html="report.body"></td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th>ردیف</th>
                  <th>کدپروژه</th>
                  <th>نام پروژه</th>
                  <th>تاریخ</th>
                  <th>گزارش</th>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>

export default {
  name: 'StaffReports',
  data () {
    return {
      id: this.$route.params.id,
      data: null,
      url: '/api/staffs/report/' + this.$route.params.id,
      pdfUrl: process.env.VUE_APP_SERVER_ADDRESS + '/staff/report/' + this.$route.params.id + '/'
      // pdfUrl: 'http://ehsanfayez.com/staff/report/' + this.$route.params.id + '/'
    }
  },
  mounted () {
    this.$send.submit('get', 'api/staffs/report/' + this.$route.params.id)
      .then(response => {
        this.data = response
      })
  }
}

</script>
